import { render, staticRenderFns } from "./zxGaikuang.vue?vue&type=template&id=66b963b0&scoped=true&"
import script from "./zxGaikuang.vue?vue&type=script&lang=js&"
export * from "./zxGaikuang.vue?vue&type=script&lang=js&"
import style0 from "./zxGaikuang.vue?vue&type=style&index=0&id=66b963b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b963b0",
  null
  
)

export default component.exports